// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"36":"d2362c24","177":"e7ae8ccd","443":"af40b224"}[chunkId] + ".css";
};